// extracted by mini-css-extract-plugin
export default {"header":"style_header__baAPd","subheader":"style_subheader__VxPpV","numbers":"style_numbers__eAQgd","floatingLabel":"style_floatingLabel__6UL8+"};